const interval = setInterval(() => {
    const button = document.querySelector(".cd-buy-button");

    if (button) {
        button.innerHTML = "Add";
    }

    const data = window.event?.detail;

    const findSelectEl = document.querySelector(".opus-price-ct-container");
    if (findSelectEl) {
        findSelectEl.remove();
    }

    let original_total_price = 0;
    let money = 0;
    let countItem = 0;
    const items = document.querySelectorAll('.cd-section-price');

    items.forEach((item) => {
        const originalPriceEl = item.querySelector('.cd-original-price');
        const moneyEl = item.querySelector('.money');

        const itemMoney = moneyEl ? parseFloat(moneyEl.textContent.replace(/[^\d-]/g, '')) || 0 : 0;
        const itemOriginalPrice = originalPriceEl ? parseFloat(originalPriceEl.textContent.replace(/[^\d-]/g, '')) || 0 : 0;

        original_total_price += itemOriginalPrice || itemMoney;
        money += itemMoney;
    });

   const itemsCount = document.querySelectorAll('.cd-number-input');

    itemsCount.forEach((item) => {
       const originalCount = parseInt(item.querySelector('.cd-number-input-field')?.value) || 0;
        countItem += originalCount;
    });

    console.log("discountdiscountdiscount", countItem);

    let discount = original_total_price - money;
    const isPriceDiscount = discount > 0;

    document.querySelectorAll('.opus-price-ct-container').forEach(el => el.remove());

    const checkoutBtn = document.querySelector(".opus-btn-checkout");
    if (checkoutBtn) {
        checkoutBtn.insertAdjacentHTML(
            "beforebegin",
            `<div class="opus-price-ct-container" 
                 style="width: 100%; display: inline-flex; padding-top: 15px; 
                        justify-content: space-between; align-items: center; 
                        font-size: 14px; font-weight: bold; gap: 10px; margin: auto;"
              >
                <span style="flex-shrink: 0; align-items:center">
                    <strong>Subtotal: ${countItem|| 0} item${countItem  > 1 ? "s" : ""}</strong>
                </span>
               <div style="display: flex; gap: 5px;  justify-content: center;  align-items: center;">
                  <span style="text-decoration: line-through; color: #ccc;">
                    ${window.OpusConvertMoney(original_total_price.toFixed(2))}
                </span>
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <span>${window.OpusConvertMoney(money.toFixed(2))}</span>
                </div>
                ${isPriceDiscount ? `
                <div style="display: flex; font-size: 13px; justify-content: space-between; align-items: center; padding: 4px; background-color: red; color: white; border-radius: 4px;">
                    <span>${window.OpusConvertMoney(discount.toFixed(2))} OFF</span>
                </div>` : ""}
               </div>
            </div>`
        );
    }

    if (!document.querySelector(".opus-extra-image") && checkoutBtn) {
        checkoutBtn.insertAdjacentHTML(
            "afterend",
            `<div class="opus-extra-image" 
                 style="width: 100%; display: flex; justify-content: center; 
                        align-items: center; gap: 10px; margin-top: 16px">
                <img src="https://cdn.shopify.com/s/files/1/0612/8697/3669/files/90-day-guarantee-checkmark.svg?v=1740125582" 
                    alt="Extra Image" 
                    style="max-width: 20px; height: auto;">
                <span style="font-size: 13px; font-weight: bold; color: #333;">
                    90-DAY SATISFACTION GUARANTEE
                </span>
            </div>`
        );
    }
}, 1000);
